// #region STTEDRA
import {
  // useDev,
  useNormalizer,
} from '@sttedra_ui/framework';
// #endregion

import AcceptedDataListModelState from './accepted-data-list.view-model';

const {
  getObjectFilled,
} = useNormalizer();

export default class AcceptedRequestViewState {
  isVisible = false;

  _registerList;
  get registerList() {
    return this._registerList;
  }
  set registerList(value) {
    if (!getObjectFilled(value)) {
      this._registerList = null;
      return;
    }

    const valueModel = new AcceptedDataListModelState(value, this.countryEU, this.isLogged);
    if (!getObjectFilled(valueModel)) {
      this._registerList = null;
      return;
    }

    this._registerList = Object.keys(valueModel).map((x) => {
      return {
        label: x, value: valueModel[x],
      };
    });
  }

  _registerTutorList;
  get registerTutorList() {
    return this._registerTutorList;
  }
  set registerTutorList(value) {
    if (!getObjectFilled(value)) {
      this._registerTutorList = null;
      return;
    }

    const valueModel = new AcceptedDataListModelState(value, this.countryEU, this.isLogged, true);
    if (!getObjectFilled(valueModel)) {
      this._registerTutorList = null;
      return;
    }

    this._registerTutorList = Object.keys(valueModel).map((x) => {
      return {
        label: x, value: valueModel[x],
      };
    });
  }

  constructor(data = null, countryEU = [], isLogged = false) {
    this.isLogged = isLogged;
    this.isVisible = false;
    this.countryEU = countryEU;
    this.registerList = data;
    this.registerTutorList = data?.legalGuardian;
  }
}
